"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-TagIcon',
};
exports.Style = {
    [exports.CSS.container]: {
        width: 'inherit',
        height: 'inherit',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        'box-sizing': 'border-box',
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        fontWeight: theme_1.DefaultTheme.font.weight.bold,
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2,
        color: theme_1.DefaultTheme.font.color.primary,
        border: '2px solid',
    },
};
//# sourceMappingURL=tag.icon.style.js.map